import React from 'react';
import {
  Box,
  Flex,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  useColorModeValue,
} from '@chakra-ui/react';

import AnalyticsPage from '../../layout/IntegraAppPage';

const DashboardSkeleton: React.FC = () => {
  const bg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'gray.700');

  return (
    <AnalyticsPage>
      <Box p={3}>
        <Flex justify="space-between" align="center" mb={4}>
          <Skeleton height="30px" width="160px" />
        </Flex>

        <SimpleGrid columns={[1, 1, 2, 2, 4]} w="100%" spacing={4} mb={6}>
          {[1, 2, 3, 4].map(item => (
            <Box
              key={item}
              bg={bg}
              borderWidth="1px"
              borderColor={border}
              borderRadius="8px"
              boxShadow="0 1px 4px rgba(15, 23, 42, 0.08)"
              minH="168px"
              p="24px"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Flex justify="space-between" align="flex-start">
                <Skeleton boxSize="44px" borderRadius="8px" />
                <Skeleton height="16px" width="70px" />
              </Flex>

              <Box>
                <Skeleton height="14px" width="120px" mb={3} />
                <Skeleton height="32px" width="160px" />
              </Box>
            </Box>
          ))}
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt={2}>
          {[1, 2].map(item => (
            <Box
              key={item}
              bg={bg}
              borderWidth="1px"
              borderColor={border}
              borderRadius="8px"
              boxShadow="0 1px 4px rgba(15, 23, 42, 0.08)"
              overflow="hidden"
            >
              <Box p={5} borderBottom="1px solid" borderColor={border}>
                <Skeleton height="24px" width="220px" mb={2} />
                <Skeleton height="16px" width="180px" />
              </Box>

              <Box p={5}>
                <Skeleton height="36px" width="180px" mb={6} />
                <SkeletonText noOfLines={3} spacing="4" />
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </AnalyticsPage>
  );
};

export default DashboardSkeleton;
